import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BG   = '#f2f2ee';
const TEXT = '#0A0A0A';
const MUTED = '#8b7d6b';
const BORDER = '#e5e0d5';
const FONT = "'Courier Prime Sans', 'Courier New', monospace";
const SZ = 'clamp(10px, 1vw, 16px)';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || null;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(username, password);
      navigate(from || (user.role === 'admin' ? '/admin' : '/portal'), { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: BG,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: FONT,
      padding: '0 10px',
    }}>
      <div style={{ width: '100%', maxWidth: 340 }}>

        <div style={{ marginBottom: 52, textAlign: 'left' }}>
          <a href="/" style={{ fontSize: SZ, letterSpacing: '0.06em', color: TEXT, textTransform: 'uppercase', fontWeight: 400, textDecoration: 'none', display: 'block' }}>
            Pierce Bancroft Townsend
          </a>
          <div style={{ fontSize: SZ, letterSpacing: '0.06em', color: MUTED, textTransform: 'uppercase', marginTop: 6 }}>
            Portal
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: 'block', fontSize: SZ, letterSpacing: '0.06em', color: MUTED, textTransform: 'uppercase', marginBottom: 8 }}>
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              style={{
                width: '100%',
                background: BG,
                border: `1px solid ${BORDER}`,
                borderBottom: `1px solid ${TEXT}`,
                color: TEXT,
                fontSize: 13,
                letterSpacing: '0.04em',
                padding: '10px 0',
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: FONT,
                borderTop: 'none',
                borderLeft: 'none',
                borderRight: 'none',
                background: 'transparent',
              }}
            />
          </div>

          <div style={{ marginBottom: 36 }}>
            <label style={{ display: 'block', fontSize: SZ, letterSpacing: '0.06em', color: MUTED, textTransform: 'uppercase', marginBottom: 8 }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              style={{
                width: '100%',
                borderBottom: `1px solid ${TEXT}`,
                color: TEXT,
                fontSize: 13,
                letterSpacing: '0.04em',
                padding: '10px 0',
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: FONT,
                border: 'none',
                borderBottom: `1px solid ${TEXT}`,
                background: 'transparent',
              }}
            />
          </div>

          {error && (
            <div style={{ fontSize: SZ, color: '#c0392b', letterSpacing: '0.06em', marginBottom: 18, textTransform: 'uppercase' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: 'transparent',
              color: loading ? MUTED : TEXT,
              border: 'none',
              padding: 0,
              fontSize: SZ,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              cursor: loading ? 'default' : 'pointer',
              fontFamily: FONT,
              fontWeight: 400,
            }}
          >
            {loading ? 'Signing in...' : 'Enter →'}
          </button>
        </form>
      </div>
    </div>
  );
}
